<!--
	LoginPage.svelte

    NOTE: this page is just a placeholder for the no longer used - About links to the main TCARE site.
-->


<script>
	import { onMount } from 'svelte';
    import { location } from 'svelte-spa-router';			// new 11/2

    // TCARE components
    import TCareLoginPopup from '../../components/popups/TCareLoginPopup.svelte';

    $: isShowing = true;

    onMount(() => {
    })

    // these functions are passed to the TCareLoginPopup

    const onSignUpClick = () => {
        console.log('LoginPage onSignUpClick');
    }

    const onLoginClick = () => {
        console.log('LoginPage onLoginClick');
    }

    const onForgotPasswordClick = () => {
        console.log('LoginPage onForgotPasswordClick');
    }

    const onEmailHelpClick = () => {
        console.log('LoginPage onEmailHelpClick');
    }

    const onPasswordHelpClick = () => {
        console.log('LoginPage onPasswordHelpClick');
    }

    const popupFunctions = {
        onSignUpClick: onSignUpClick,
        onLoginClick: onLoginClick,
        onForgotPasswordClick: onForgotPasswordClick,
        onEmailHelpClick: onEmailHelpClick,
        onPasswordHelpClick: onPasswordHelpClick
    }

</script>

<style>

    .login-page {
        width: 100%;
        height: 100vh;
        background: linear-gradient(#391A52, #611C73);
    }

    .login-page img {
        position: fixed;
        width: 554px;
        height: 325px;
        top: 117px;        
        left: 12%;
    }

</style>

<div class="login-page">
    <img src='/img/Family_Group_Photo.png' alt='Family Group' draggable="false">
    <TCareLoginPopup {isShowing} {popupFunctions}/>
</div>
